import {
  activeWorkspaceIcon,
  close,
  workspaceIcon,
} from "@/components/icons/SVGIcons";
import EditableTextWorkspace from "@/lib/EditableTextWorkspace";
import { IActiveTabData } from "@/lib/widgetsLayoutDir";
import { Button } from "@/components/UI/Button";
import workspacesTabsStore from "@/store/workspacesTabsStore";
import {
  deleteWorkspaceTabFromUser,
  updateTabDataAction,
} from "@/store/workspacesTabsStoreACTIONS";
import React from "react";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { cubeCustomColors } from "../../../../tailwind.config";
import SidebarHeading from "./SidebarHeading";

const WorkspaceButtonContainer = ({
  toolbarOpen,
  theme,
  getAccessTokenSilently,
}: {
  toolbarOpen: boolean;
  theme: string | undefined;
  getAccessTokenSilently: Function;
}) => {
  const tabNamesAndActive = workspacesTabsStore(
    (state) => state.tabNamesAndActive,
  );

  const cubeBase700 = cubeCustomColors.cubeBase[700];
  const cubeBaseDark700 = cubeCustomColors.cubeBaseDark[700];

  function changeActiveTab(item: IActiveTabData) {
    const newJSONdataWithActiveTabs = tabNamesAndActive.map((tab) => ({
      ...tab,
      active: tab.tabId === item.tabId,
    }));
    updateTabDataAction(newJSONdataWithActiveTabs, getAccessTokenSilently);
  }

  function deleteTabOnClick(
    tabId: number,
    e: React.MouseEvent<HTMLButtonElement>,
  ) {
    e.stopPropagation();
    if (tabNamesAndActive.length == 1) {
      toast.error("Unable to delete last tab.");
    } else {
      deleteWorkspaceTabFromUser(getAccessTokenSilently, tabId);
    }
  }

  return (
    <div>
      {toolbarOpen && <SidebarHeading heading={"Workspaces"} />}
      {tabNamesAndActive.map((tab, index) => (
        <div
          className="flex w-full items-center justify-between"
          key={tab.tabId}
        >
          <Button
            variant="sidebarItem"
            onClick={() => changeActiveTab(tab)}
            className={`${tab.active ? "border-l" : "rounded-l-lg "} `}
          >
            {/* Below styles should be kept to match SVGandTextContainer*/}
            <div
              className={`${tab.active ? "text-black dark:text-cubeBase-800" : "text-cubeBase-600 hover:text-black dark:text-cubeBase-600 hover:dark:text-cubeBase-800"} flex h-[35px] w-[35px] items-center justify-center`}
              data-tooltip-id={toolbarOpen ? "" : tab.active + tab.displayName}
            >
              {tab.active ? activeWorkspaceIcon : workspaceIcon}
            </div>
            <div className={`w-full ${toolbarOpen ? "" : "hidden"} `}>
              <EditableTextWorkspace
                initialText={tab.displayName}
                tabNamesAndActiveData={tabNamesAndActive}
                getAccessTokenSilently={getAccessTokenSilently}
                tabIdClickedOn={tab.tabId}
                indexOfWorkspaceTab={index}
              />
            </div>
          </Button>
          {tabNamesAndActive.length > 1 && (
            <Button
              variant="exit"
              className={`${tab.active ? " text-black dark:text-white" : ""} ${toolbarOpen ? "" : "hidden"}`}
              onClick={(e) => {
                deleteTabOnClick(tab.tabId, e);
              }}
              onDoubleClick={(e) => e.stopPropagation()}
            >
              {close}
            </Button>
          )}

          <Tooltip
            id={tab.active + tab.displayName}
            place="right-start"
            variant="info"
            className="z-40 "
            clickable={true}
            // openOnClick={true}
            opacity={1}
            style={{
              backgroundColor: theme == "dark" ? cubeBaseDark700 : cubeBase700,
            }}
            border="1px solid gray"
            offset={toolbarOpen ? 40 : 20}
          >
            {/* IN THE TOOLTIP WHEN THE SIDEBAR IS COLLAPSED. */}
            <div className="flex text-black dark:text-gray-200">
              {/* &quot; */}
              <EditableTextWorkspace
                initialText={tab.displayName}
                tabNamesAndActiveData={tabNamesAndActive}
                getAccessTokenSilently={getAccessTokenSilently}
                tabIdClickedOn={tab.tabId}
                formCollapsedSidebar={true}
                indexOfWorkspaceTab={index}
              />
              {/* &quot; */}
            </div>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};

export default WorkspaceButtonContainer;
